declare const window: any;
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthorizeService, IUser } from 'src/api-authorization/authorize.service';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';
import { DialogUserMessageComponent } from '../dialogs/dialogUserMessage.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['footer.component.scss']
})
export class AppFooterComponent implements OnInit {
  public isAuthenticated: boolean = false;
  public player: Player = new Player();
  public playerId: string = "";

  constructor(private authorizeSvc: AuthorizeService, private routerLink: Router,
    public userSvc: UserService, private dialog: MatDialog) {
  }

  // NOT sure why this gets called THREE times
  ngOnInit(): void {
    this.authorizeSvc.isAuthenticated().subscribe(bFlag => {
      this.isAuthenticated = bFlag;
      if (this.isAuthenticated) {
        this.authorizeSvc.getUser().pipe(take(1)).subscribe((result: IUser) => {
          this.playerId = result.sub;
        });
      }
    });
  }

  public msgDialog(evt) {
    evt.preventDefault();
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(DialogUserMessageComponent, dialogConfig);
  }

  public clearImpersonte(evt: any) {
    evt.preventDefault();
    document.cookie = `impersonate=; path=/`;
    this.userSvc.clearCache();
    localStorage.removeItem('ladderId');
    localStorage.removeItem('levelId');
    window.location.reload();
  }
}
